/**
 * Layout of the Home Assistant flow graph (page-local pixels): inbound nodes
 * in columns left of the plate, outbound nodes in columns right of it.
 *
 *   entity · [switch] · binding | plate | trigger · condition · action · target entity
 */
export const HASS_NODE_SIZE = Object.freeze({ width: 180, height: 44 });
export const HASS_COLUMN = HASS_NODE_SIZE.width + 40;
// Row pitch of the automatic layout, with room between nodes.
export const HASS_ROW = 70;

export function hassColumns(plateWidth = 0) {
    const right = plateWidth + 40;
    return {
        entityIn: -2 * HASS_COLUMN,
        binding: -HASS_COLUMN,
        trigger: right,
        condition: right + HASS_COLUMN,
        action: right + 2 * HASS_COLUMN,
        entityOut: right + 3 * HASS_COLUMN,
    };
}
